import React from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import { ChevronRight } from "@mui/icons-material";

interface SaveAndContinueProps {
  onConfirm: () => void;
  buttonText?: string;
  disabled?: boolean;
  loading?: boolean;
}

export const SaveAndContinueButton: React.FC<SaveAndContinueProps> = ({
  buttonText = "Save & Continue",
  onConfirm,
  disabled = false,
  loading = false,
}) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}>
      <Button
        variant="contained"
        endIcon={
          loading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            <ChevronRight />
          )
        }
        onClick={onConfirm}
        disabled={disabled || loading}
        sx={{
          bgcolor: "success.main",
          color: "white",
          px: 4,
          py: 1.5,
          fontWeight: 600,
          fontSize: 15,
          "&:hover": { bgcolor: "success.dark" },
        }}
      >
        {loading ? "Setting up..." : buttonText}
      </Button>
    </Box>
  );
};
